import { useState, useEffect } from "react";

const ProjectDetails = ({ initialData, onFormChange }) => {
  const [projectName, setProjectName] = useState(initialData?.name || "");
  const [description, setDescription] = useState(
    initialData?.description || ""
  );
  const [completion, setCompletion] = useState(Number(initialData?.completion));
  const [type, setType] = useState(initialData?.type || "");

  // Form verileri değiştiğinde onFormChange ile üst bileşene bildir
  useEffect(() => {
    onFormChange({
      name: projectName,
      description,
      completion,
      type,
    });
  }, [projectName, description, completion, type, onFormChange]);

  return (
    <div className="detay-container focus:border-none h-auto divide-y-[1px]">
      <h2 className="text-xl font-semibold text-dark ">Genel Bilgiler</h2>

      {/* Proje adı ve tamamlama yüzdesi için flex-grid düzeni */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
        <div className="flex flex-col gap-2 mt-4">
          <label className="labelEdit">Projenin Adı</label>
          <input
            type="text"
            className="custom-input rounded-xl px-5"
            value={projectName}
            placeholder="E-ticaret"
            onChange={(e) => setProjectName(e.target.value)}
          />
        </div>

        <div className="flex flex-col mt-4">
          <label className="labelEdit">Projeyi Tamamlama Yüzdesi</label>
          <div className="flex items-center h-[48px] gap-2">
            <input
              type="range"
              min="0"
              max="100"
              value={completion}
              onChange={(e) => setCompletion(Number(e.target.value))}
              className="w-full accent-black"
            />
            <span className="font-semibold text-dark text-xs">
              {completion}%
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-2 border-none">
        <label className="labelEdit">Proje Hakkında</label>
        <textarea
          className="custom-input rounded-xl p-4 min-h-[176px] h-auto outline-none resize-none"
          value={description}
          placeholder="Açıklama"
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </div>
  );
};

export default ProjectDetails;
